import {connect} from "react-redux";
import SaveUCDLead from "./Save";
import {bindActionCreators} from "redux";
import {saveLead, getLeadById, searchDealerMaster, } from "../../../../../service/Lead/action";
import {locationPinCode} from "../../../../../service/locations/action";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {firmType} from "../../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    lead:state.Lead.lead,
    leadById:state.Lead.leadById,
    searchMasterDealer:state.Lead.searchMasterDealer,
    pincodeData: state.locationReducer.pincodeData,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    firmTypesValue:state.Dealer.firm,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveLead,
            getLeadById,
            searchDealerMaster,
            locationPinCode,
            documentUploadUrlPublic,
            firmType
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SaveUCDLead);
